<template>
  <form v-on="$listeners" v-bind="$attrs">
    <slot></slot>
  </form>
</template>

<script>
export default {
  name: 'WCForm',
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  watch: {
    'form.$invalid': {
      handler(value) {
        this.$emit('update:valid', !value);
      },
    },
    'form.$model': {
      deep: true,
      handler(value) {
        this.$emit('update:value', value);
      },
    },
  },
  provide() {
    return { form: this.form };
  },
};
</script>

<style scoped lang="scss"></style>
